const WARNING_MESSAGE =
  "This action will create a new copy for all users. If you just want to make a copy for testing purpose, please use Copy functionality";

const LABELS= {
  CREATE_NEW_DEFAULT_SCENARIO: 'Create a new default scenario'
}

export { WARNING_MESSAGE, LABELS };